module.exports = __webpack_public_path__ + "img/blog.b340e1ab.svg";